import axios from 'axios'
import { authHeader } from '@/util/helpers'
import getEnv from '@/util/env'

const host = getEnv('VUE_APP_API_HOST')
// const environment = getEnv('VUE_APP_ENVIRONMENT')

const state = {
  items: [],
  status_types: [],
  auth_types: [],
  waf_types: [],
  status: '',
}

const mutations = {
  'GET_ITEMS' (state) {
    axios
      .get(
        `${host}/v2/contracts/`,
        {
          headers: authHeader(),
        },
      )
      .then(response => {
      
        state.items = response.data.filter(element => !element.contract_number.includes('888'))
      
        const status = []
        const auth = []
        const waf = []

        response.data.forEach(element => {
          status.push(element.status)
          auth.push(element.authentication)
          waf.push(element.waf_type)
        })
        state.status_types = [...new Set(status)]
        state.auth_types = [...new Set(auth)]
        state.waf_types = [...new Set(waf)]
      })
  },
}

const getters = {
  items: state => {
    return state.items
  },
  status_types: state => {
    return state.status_types
  },
  auth_types: state => {
    return state.auth_types
  },
  waf_types: state => {
    return state.waf_types
  },
}

const actions = {
  load ({ commit }) {
    commit('GET_ITEMS')
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
